import { useEffect, useState } from 'react';

// Phone-first breakpoint shared by the whole mobile foundation. Matches the
// 768px tablet/mobile block in App.css so the sidebar drawer, tab bar and
// page chrome all flip together.
export const MOBILE_QUERY = '(max-width: 768px)';

export default function useIsMobile() {
  const get = () => (typeof window !== 'undefined' && window.matchMedia
    ? window.matchMedia(MOBILE_QUERY).matches : false);
  const [isMobile, setIsMobile] = useState(get);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const mq = window.matchMedia(MOBILE_QUERY);
    const onChange = e => setIsMobile(e.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else mq.addListener(onChange);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', onChange);
      else mq.removeListener(onChange);
    };
  }, []);
  return isMobile;
}
